import { Button, useTheme } from '@repo/ui-web';

const options = ['light', 'dark'] as const;

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <div className="flex items-center gap-1">
      {options.map((option) => (
        <Button
          key={option}
          size="sm"
          variant={theme === option ? 'default' : 'secondary-outline'}
          onClick={() => setTheme(option)}
        >
          {option}
        </Button>
      ))}
    </div>
  );
}
